import { cn } from '@/utils/tailwind.util';
export interface MapTemplateBannerProps {
  /** 배너 이미지 URL */
  bannerUrl: string;
  /** 이미지의 alt 텍스트 */
  alt?: string;
  /** 추가 스타일링을 위한 선택적 className */
  className?: string;
}

/**
 * MapTemplateBanner - 맵 템플릿 이미지를 표시하는 전체 너비 배너
 *
 * @description
 * 퀴즈 상세 페이지 상단에 맵 템플릿 이미지가 있는 전체 너비 배너를 렌더링합니다.
 * 이미지는 최적의 표시를 위해 object-fit: cover와 object-position: center를 사용합니다.
 * 퀴즈 상세 정보 카드는 하단에서 약 60px 겹칩니다.
 *
 * 더 나은 성능과 안정성을 위해 templateName을 통해 해석된 정적 배너 이미지를 사용합니다.
 *
 * @example
 * ```tsx
 * <MapTemplateBanner
 *   templateName={quizData.templateName}
 *   alt={quizData.templateName}
 * />
 * ```
 */
export const MapTemplateBanner = ({
  bannerUrl,
  alt = 'Map template banner',
  className
}: MapTemplateBannerProps) => {
  return <div className={cn('relative h-[86px] tablet-sm:h-[136px] w-full overflow-hidden', className)} data-sentry-component="MapTemplateBanner" data-sentry-source-file="MapTemplateBanner.tsx">
      <img src={bannerUrl} alt={alt} className="h-full w-full object-cover object-center" />
      {/* 겹치는 콘텐츠의 텍스트 가독성 향상을 위한 그라데이션 오버레이 */}
      <div className="absolute inset-x-0 bottom-0 h-20" style={{
      background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.4) 100%)'
    }} />
    </div>;
};